// extracted by mini-css-extract-plugin
export default {"proxyStatus":"ProxyStatus_proxyStatus__IDjCw","value":"ProxyStatus_value__ydgEA","isGreen":"ProxyStatus_isGreen__lnsJM","isRed":"ProxyStatus_isRed__r-1QA"};